import { render, staticRenderFns } from "./roomSettings.vue?vue&type=template&id=4412021e&scoped=true&"
import script from "./roomSettings.vue?vue&type=script&lang=js&"
export * from "./roomSettings.vue?vue&type=script&lang=js&"
import style0 from "./roomSettings.vue?vue&type=style&index=0&id=4412021e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4412021e",
  null
  
)

export default component.exports